import slider1 from "./assets/images/coffee-slider-1.png";
import slider2 from "./assets/images/coffee-slider-2.png";
import slider3 from "./assets/images/coffee-slider-3.png";

export const favoritesJSON = [
  {
    img: slider1,
    name: "S’mores Frappuccino",
    description:
      "This new drink takes an espresso and mixes it with brown sugar and cinnamon before being topped with oat milk.",
    price: "$5.50",
  },
  {
    img: slider2,
    name: "Caramel Macchiato",
    description:
      "Fragrant and unique classic espresso with rich caramel-peanut syrup, with cream under whipped thick foam.",
    price: "$5.00",
  },
  {
    img: slider3,
    name: "Ice coffee",
    description:
      "A popular summer drink that tones and invigorates. Prepared from coffee, milk and ice.",
    price: "$4.50",
  },
];
